(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cleancaro-logo-strip"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cc-logo-marquee')) {
  customElements.define('cc-logo-marquee', class extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.cc-logos__viewport');
      this.belt = this.querySelector('.cc-logos__belt');
      this.group = this.querySelector('.cc-logos__track');
      this.abort = new AbortController();
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.viewport);
      this.observer.observe(this.group);
      this.update();
    }
    update() {
      const width = this.group.getBoundingClientRect().width;
      const overflow = width > this.viewport.clientWidth + 1;
      this.classList.toggle('is-overflowing', overflow);
      this.style.setProperty('--cl-distance', width + 'px');
      this.style.setProperty('--cl-duration', (width / (Number(this.dataset.speed) || 25)) + 's');
      if (overflow && !this.clone) {
        this.clone = this.group.cloneNode(true);
        this.clone.setAttribute('aria-hidden', 'true');
        this.clone.setAttribute('inert', '');
        this.clone.querySelectorAll('[data-shopify-editor-block]').forEach(el => el.removeAttribute('data-shopify-editor-block'));
        this.belt.appendChild(this.clone);
      } else if (!overflow && this.clone) {
        this.clone.remove(); this.clone = null;
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.abort?.abort();
      this.clone?.remove(); this.clone = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
